<template>
  <card>
    <div v-if="$store.state.navs[$options.name]">
      <list
        :itemLink="itemLink"
        :columns="columns"
        :modalCreate="modalCreate"
        :removeLink="removeLink"
        :cardLink="cardLink"
        :isUpdate="true"
        :setImport="false"
        :functions="functions"
        @change="change"
        :exportFields="exportFields"
        @changeFunction="changeFunction"
      />
    </div>
  </card>
</template>

<script>
import List from "../components/List";

export default {
  name: "Clients",
  components: {
    List,
  },
  data() {
    return {
      exportFields: {
        "Номер телефона": {
          type: "string",
          field: "phone",
          callback: (val) => {
            try {
              return val;
              // return val.slice(1);
            } catch (error) {
              return val;
            }
          },
        },
        Имя: "first_name",
        Фамилия: "last_name",
        Email: "email",
        "В корзине": "cart_count",
        "В избранном": "wish_count",
        "Всего заказов": "checks_count",
        "Выполненно заказов": "paid",
        "Дата регистрации": "created_at",
        Корзина: {
          field: "cart",
          callback: (value) => {
            let productArray = [];
            for (let i = 0; i < value.length; i++) {
              productArray.push(value[i].sku);
            }
            return productArray.join(", ");
          },
        },
        Избранное: {
          type: "string",
          field: "wish",
          callback: (value) => {
            let productArray = [];
            for (let i = 0; i < value.length; i++) {
              productArray.push(value[i].sku);
            }
            return productArray.join(", ");
          },
        },
      },
      functions: [{ id: 1, title: "Установить группу" }],
      //end callback data
      /**Меняю ссылки на модель */
      modalCreate: "client",
      removeLink: "",
      cardLink: "client",
      itemLink: "clients/list",
      /**Табличные филды */
      columns: [
        {
          key: "phone",
          title: "Номер телефона",
          checkbox: false,
          control: false,
          align: "left",
        },
        {
          key: "first_name",
          title: "Имя",
          checkbox: false,
          control: false,
          align: "left",
        },
        {
          key: "last_name",
          title: "Фамилия",
          checkbox: false,
          control: false,
          align: "left",
          type: "object",
        },
        {
          key: "email",
          title: "Эл. почта",
          checkbox: false,
          control: false,
          align: "left",
        },
        {
          key: "cart_count",
          title: "В корзине",
          checkbox: false,
          control: false,
          align: "left",
        },
        {
          key: "wish_count",
          title: "В избранном",
          checkbox: false,
          control: false,
          align: "left",
        },
        {
          key: "checks_count",
          title: "Всего заказов",
          checkbox: false,
          control: false,
          align: "left",
        },
        {
          key: "paid",
          title: "Выполненные заказы",
          checkbox: false,
          control: false,
          align: "left",
        },
        {
          key: "created_at",
          title: "Дата регистрации",
          checkbox: false,
          dateTimeFormat: true,
        },
        {
          detail: true,
        },
      ],
      value: null,
    };
  },
  methods: {
    changeFunction(val) {
      if (val == 1) {
        this.$store.dispatch("openModal", {
          model: "group",
          route: "admin/clients/relate/group",
        });
        this.$store.dispatch("selectValue", this.value);
      }
    },
    change(val) {
      this.value = Array.isArray(val) ? val : [val];
    },
  },
};
</script>
<style>
</style>
